<div class="cpcontent">
    <h2>Config Table in Database</h2>
    <div class="row">
        <div class="col-md-4">
            <sa-input-number [(text)]="config.uploadInterval" [title]="'Upload Interval [ms]' "></sa-input-number>
            <sa-input-number [(text)]="config.discardInterval" [title]="'Discard Interval [ms]' "></sa-input-number>
            <sa-input-number [(text)]="config.displayInterval" [title]="'Display Interval [ms]' "></sa-input-number>
            <sa-input-number [(text)]="config.debugMode" [title]="'Debug Mode' "></sa-input-number>
            <sa-input-number [(text)]="config.scenarioId" [title]="'Scenario Id' "></sa-input-number>
            <br>
            <button class="btn btn-primary" (click)="post()">Post</button>
        </div>
        <div class="col-md-8">
            This record in the table "Config" stores basic configuration data:
            <ul>
                <li>Upload Interval: Is the interval between consequtives uploads from the android to the database</li>
                <li>Discard Interval: not used right now</li>
                <li>Display Interval: Is the interval bewteen calculating and updating the sensor display</li>
                <li>Debug Mode: "0" means no debugging, 1 means debugging</li>
                <li>Scenario Id: Only the scenario with matching id can have a debug mode of 1; all other scenraios will always have 0</li>
            </ul>
        </div>
    </div>
</div>